"use client";

import NextError from "next/error";

export default function GlobalError() {
    return (
        // global-error must include html and body tags
        <html>
            <body>
                <NextError statusCode={0} title={"Internal Server Error"} />
            </body>
        </html>
    );
}
